(function() {
  'use strict';

  class BentoParallax {
    constructor() {
      this.section = null;
      this.items = [];
      this.ticking = false;
      this.isInitialized = false;
    }

    init() {
      this.section = document.querySelector('[data-bento-parallax]');
      if (!this.section) return;

      this.items = Array.from(this.section.querySelectorAll('[data-parallax-speed]'));
      if (!this.items.length) return;

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      this.isInitialized = true;
      this.update();
    }

    handleScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    update() {
      if (!this.isInitialized) return;

      const viewportHeight = window.innerHeight;

      this.items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const speed = parseFloat(item.dataset.parallaxSpeed) || 0;

        // Only animate when element is near viewport (+/- 100px buffer)
        if (rect.top < viewportHeight + 100 && rect.bottom > -100) {
          const elementCenter = rect.top + rect.height / 2;
          const viewportCenter = viewportHeight / 2;
          const distance = elementCenter - viewportCenter;
          const offset = distance * speed;
          item.style.transform = `translate3d(0, ${offset}px, 0)`;
        }
      });
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      this.items.forEach(item => {
        item.style.transform = '';
      });
      this.isInitialized = false;
    }
  }

  function initBentoParallax() {
    const bp = new BentoParallax();
    bp.init();
    window.bentoParallax = bp;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBentoParallax);
  } else {
    initBentoParallax();
  }
})();
